export const JSON_DEFAULT_SCHEMA = {
  type: 'object',
  properties: {},
};

export const TEXTE = 'string';
export const NOMBRE = 'number';
export const OUI_NON = 'boolean';
export const TABLEAU = 'array';

export const TYPE_PROPRERTIES = [
  { code: TEXTE, libelle: 'addEditNomenclatureType.types.string' },
  { code: NOMBRE, libelle: 'addEditNomenclatureType.types.number' },
  { code: OUI_NON, libelle: 'addEditNomenclatureType.types.booleen' },
  { code: TABLEAU, libelle: 'addEditNomenclatureType.types.array' },
];
